// extracted by mini-css-extract-plugin
module.exports = {"paras":"features_paras__Ertlj"};